/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookNotepadIcon20Solid = forwardRef('BookNotepadIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 4c0-1.398.956-2.572 2.25-2.905v17.81A3.001 3.001 0 0 1 3 16V4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 19H6.75V1H14a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3ZM9.75 5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM9 8.75A.75.75 0 0 1 9.75 8h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 9 8.75ZM9.75 11a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" })));
});
